import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDFPHATLQC8P14voq-eMM1WxKkYxw--fGk",
  authDomain: "portfolio-1e95a.firebaseapp.com",
  databaseURL: "https://portfolio-1e95a.firebaseio.com",
  projectId: "portfolio-1e95a",
  storageBucket: "portfolio-1e95a.appspot.com",
  messagingSenderId: "865943787945",
  appId: "1:865943787945:web:8468d54d32cdf0d6f3ccb8"
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;